/* eslint-disable */

import { HiX } from "react-icons/hi";
import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useUser } from "contexts/UserContext";
import Links from "./components/Links";
import SidebarCard from "components/sidebar/components/SidebarCard";
import { resolvePortalPath } from "utils/portalPath";
import { useMobileNavigationOrder } from "components/navbar/MenuOrderSettings";
import { API_BASE_URL } from "utils/api";

const Sidebar = ({ open, onClose }) => {
  const { user } = useUser();
  const [autoCloseOnMobile, setAutoCloseOnMobile] = useState(true);
  const { orderedRoutes } = useMobileNavigationOrder();

  const handleMenuClick = () => {
    // Only close on mobile/small screens (less than xl breakpoint: 1280px)
    const isMobileView = window.innerWidth < 1280;
    if (autoCloseOnMobile && isMobileView) {
      onClose();
    }
  };

  return (
    <div
      className={`sm:none no-scrollbar fixed !z-50 flex h-full overflow-y-auto overflow-x-hidden w-64 flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all duration-300 ease-in-out dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${open ? "translate-x-0" : "-translate-x-96"
        }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[28px] mt-[30px] flex items-center gap-3`}>
        {user?.companyLogo && (
          <div className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-gray-50 p-1 dark:bg-white/5">
            <img
              src={user.companyLogo.startsWith('http') ? user.companyLogo : `${API_BASE_URL}${user.companyLogo}`}
              alt="logo"
              className="h-full w-full object-contain"
            />
          </div>
        )}
        <div className="font-poppins text-xl sm:text-[26px] font-bold uppercase tracking-tight text-amber-500 dark:text-white truncate">
          {(user?.companyShortName || user?.company_short_name)?.trim() || "Mellbizz"}
        </div>
      </div>
      <div className="mt-[24px] mb-4 h-px bg-gray-200 dark:bg-white/10" />

      {/* Nav item */}

      <ul className="mb-auto flex w-full flex-col gap-2 px-4 pt-1 transition-all duration-300 ease-in-out">
        <Links
          routes={orderedRoutes}
          onMenuClick={handleMenuClick}
          autoCloseOnMobile={autoCloseOnMobile}
          onToggleAutoClose={() => setAutoCloseOnMobile(!autoCloseOnMobile)}
        />
        <Link to={resolvePortalPath("menu-order", user?.role)} onClick={handleMenuClick}>
          <li className="relative mb-2 flex w-full cursor-pointer items-center gap-3 rounded-xl px-4 py-3 transition-all duration-300 ease-in-out hover:bg-gray-100 dark:hover:bg-navy-700">
            <span className="flex items-center justify-center text-brand-500">⇅</span>
            <p className="leading-1 flex-1 font-medium text-gray-600 dark:text-gray-300">Menu order</p>
          </li>
        </Link>
      </ul>

      {/* Free Horizon Card */}
      <div className="flex justify-center" style={{ padding: "0px 20px 0px 20px", top: "35px", position: "relative" }}>
        {/* <SidebarCard /> */}
      </div>

      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;
